module.exports = __webpack_public_path__ + "img/41.7961a953.jpg";